export class CancelledError extends Error {

	constructor(message) {
		super(message);
		this.name = "CancelledError";
	}

}

export class CancelablePromise extends Promise {

	/**
	 * Returns a normal Promise object on .then/.catch/.finally methods, instead of a CancelablePromise.
	 *
	 * @return {PromiseConstructor}
	 */
	static get [Symbol.species]() {
		return Promise;
	}

	get [Symbol.toStringTag]() {
		return "CancelablePromise";
	}

	constructor(executor) {
		const promise = {};
		const onCancel = callback => promise.cancel = callback;

		super((resolve, reject) => { promise.reject = reject; executor(resolve, reject, onCancel); });

		this.promise = promise;
		this.isCancelled = false;
	}

	cancel() {
		if(this.promise.cancel) {
			if(this.isCancelled)
				return;
			this.isCancelled = true;
			this.promise.cancel();
			this.promise.reject(new CancelledError);
		}
	}

}

export default CancelablePromise;

/*
const pro = new CancelablePromise((fulfill, reject, onCancel) => {
	console.log("promise");
	const timer = setTimeout(() => fulfill("YES"), 1000);
	onCancel(() => {
		console.log("cancel");
		clearTimeout(timer);
	});
});

pro.then((d) => { console.log("fin", d); }).catch(() => console.log("cancelled"));

setTimeout(() => pro.cancel(), 500);
*/
